import React, { FunctionComponent } from 'react';

import { I18n } from 'common/i18n';
import { VARIANTS } from 'common/components/Button';
import { ForgeDialog, ForgeToolbar, ForgeButton } from '@tylertech/forge-react';

interface ConfirmationModalProps {
  /** Function to call when clicking the confirm button */
  onAgree: () => void;

  /** Function to call when clicking the cancel button */
  onCancel: () => void;

  /** Text to put inside cancel button; defaults to "Cancel" */
  cancelButtonText?: string;

  /** Whether or not to hide the cancel button. It is shown by default. */
  hideCancelButton?: boolean;

  /** Text to put inside agree button; defaults to "OK" */
  agreeButtonText?: string;

  /** Variant to use for confirm button; defaults to PRIMARY. Forge version Only ERROR is used */
  agreeButtonVariant?: VARIANTS;

  /** Optional text to show in modal header */
  headerText?: string;
}

const ConfirmationModal: FunctionComponent<ConfirmationModalProps> = ({
  children,
  onCancel,
  onAgree,
  headerText,
  cancelButtonText,
  agreeButtonText,
  agreeButtonVariant,
  hideCancelButton,
}) => (
  <ForgeDialog
    open={true}
    on-forge-dialog-close={onCancel}
    aria-labelledby="confirmation-modal-title"
    data-testid="confirmation-modal"
  >
    <div className="confirmation-dialog-container-forged">
      <div className="container-body">
        <h1 id="confirmation-modal-title" className="forge-typography--subheading4 forge-header-title">
          {headerText}
        </h1>
        <p className="forge-typography--body2 confirmation-dialog-body">{children}</p>
      </div>
      <ForgeToolbar inverted={true}>
        {!hideCancelButton && (
          <ForgeButton
            onClick={onCancel}
            className="confirmation-cancel"
            slot="end"
            variant="outlined"
            data-testid="confirmation-cancel-button"
          >
            {cancelButtonText || I18n.t('shared.components.confirmation.cancel')}
          </ForgeButton>
        )}
        <ForgeButton
          onClick={onAgree}
          className={`confirmation-accept ${agreeButtonVariant === VARIANTS.ERROR ? 'confirmation-forge-danger-style' : ''}`}
          slot="end"
          variant="raised"
          data-testid="confirmation-accept-button"
          forge-dialog-focus="true"
        >
          {agreeButtonText || I18n.t('shared.components.confirmation.agree')}
        </ForgeButton>
      </ForgeToolbar>
    </div>
  </ForgeDialog>
);

export default ConfirmationModal;
